<template>
    <Structure_Popup id="link-choise" class="fixed">
        <template v-slot:popup-header>
            <div class="title-buttons" style="margin-top: 0">
                <div class="title">
                    {{$t('Link')}}
                </div>
                <div class="buttons">
                    <btn square remove @click="remove">
                        <tooltip :text="$t('Remove link')">
                            <i class="fal fa-trash"></i>
                        </tooltip>
                    </btn>
                    <btn square @click="$emit('close')">
                        <i class="fal fa-times"></i>
                    </btn>
                </div>
            </div>
        </template>
        <template v-slot:popup-content>
            <div class="volets content">
                <div class="volet" v-for="(volet,key) in story.voletsContent.get()" :key="key" :class="story.voletsContent.isActive(key) ? 'active' : ''"
                     @click="story.voletsContent.setActive(key)">
                    <div class="text">
                        <i class="fal" :class="$store.getters.iconByType(volet.type)"></i>
                        {{ $t(volet.label) }}
                    </div>
                    <div v-html="css"></div>
                </div>
            </div>
            <div class="volets-content">
                <Story_Card
                    :type="story.voletsContent.getCurrent().type"
                    :story="story"
                    :selected="{id:link.getId(),type:link.objectType}"
                    @add="add(story.voletsContent.getCurrent().type)"
                    @select="select"
                />
<!--                <div v-else class="p-2">-->
<!--                    <input-textarea :placeholder="$t('Annotation')" v-model="annotationText" @change="saveAnnotation"/>-->
<!--                    <div class="flex justify-end p-1" >-->
<!--                        <btn icon border @click="$emit('close')">-->
<!--                            <i class="fal fa-save"></i> {{$t('Save')}}-->
<!--                        </btn>-->
<!--                    </div>-->
<!--                </div>-->
            </div>
        </template>
    </Structure_Popup>
</template>

<script>
    import Btn from "@/modules/buttons/btn";
    import {story} from "@/class/story";
    import Story_Card from "@/views/story/Story_Cards";
    import InputTextarea from "@/modules/input/input-textarea";
    import events from "@/events/events";
    import Tooltip from "@/modules/tooltip";
    import Structure_Popup from "@/views/structures/Structure_Popup";
    import {baseModelLink} from "@/class/baseModel";
    import {annotation} from "@/class/annotation/annotation";
    export default {
        name: "LinkContent",
        components: {Structure_Popup, Tooltip, InputTextarea, Story_Card, Btn},
        props: {
            storyId:{type:Number, default:0},
            baseObject:{type:Object, default: () => new baseModelLink()}
        },
        data(){
            return {
                story:new story(),
                annotationText:"",
            }
        },
        methods: {
            add(type){
                this.$emit("close")
            },
            async select(item){
                
                if(this.link.objectType === "annotation" && item.objectType !== "annotation") {
                    console.log("TRY DELETE")
                    await this.link.delete();
                }
                
                this.link.setData(item, this.storyId)
                
                this.baseObject.save()
                this.$emit("close")
                events.$emit("interactive-image:storage:update")
            },
            async saveAnnotation(){
                
                
                let annot = new annotation().setStoryId(this.storyId)
                
                if(this.link.objectType === "annotation"){
                    annot = this.link.content;
                }
    
                annot.text = this.annotationText;
                await annot.save();

                this.link.setData(annot)
                
                this.baseObject.save()
    
            },
            remove(){
                return this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: this.$t('Confirm'),
                    text: this.$t("Do you really want to remove this link ?"),
                    acceptText:this.$t('Yes, remove it'),
                    cancelText:this.$t('No'),
                    accept: this.removeConfirm
                })
            },
            async removeConfirm(){
                await this.link.delete();
                await this.baseObject.save();
                this.$emit("close")
            },
            keydown(e){
                if(e.keyCode === 27){
                    this.$emit("close")
                }
            }
        },
        computed:{
            link(){
                return this.baseObject.link;
            },
            css(){
                let type = this.story.voletsContent.getCurrent().type
                return "<style>:root { --cActiveSub : "+this.$store.getters.colorByType(type)+";}</style>"
            }
        },
        mounted() {
            this.story.setId(this.storyId);
            this.story.load();
            
            if(this.link.is("annotation")) {
                this.annotationText = this.link.content.text;
            }
            
            if(this.link.exist()){
                this.story.voletsContent.setActive(this.story.voletsContent.get().findIndex(v => v.type === this.link.objectType))
            }
            
            document.addEventListener('keydown',this.keydown)
        },
        destroyed() {
            document.removeEventListener('keydown',this.keydown)
        }
    }
</script>